// ФТУЕ.0: компактный переключатель языка интерфейса (RU / EN).
//
// Две кнопки рядом. Текущий язык — подсвечен фракционным неоном.
// Используется и в Pre-FTUE экране выбора языка, и в настройках профиля.
//
// EN-локаль пока fallback на RU (см. app/src/i18n/locales/en.json) —
// большая часть текстов покажется на русском. По мере подготовки
// переводов EN — кнопка начнёт работать полноценно.

import { useTranslation } from 'react-i18next';
import { useLocale } from '../i18n/useLocale';
import { useTelegram } from '../telegram/useTelegram';

export function LanguagePicker({ size = 'md' }: { size?: 'md' | 'lg' }) {
  const { t } = useTranslation();
  const { locale, setLocale } = useLocale();
  const { hapticTap } = useTelegram();

  const isLg = size === 'lg';
  const btnPad = isLg ? '14px 22px' : '8px 14px';
  const btnFs  = isLg ? 16 : 13;

  function btn(code: 'ru' | 'en', flag: string, label: string) {
    const active = locale === code;
    return (
      <button
        type="button"
        onClick={() => { hapticTap(); setLocale(code); }}
        style={{
          flex: 1,
          padding: btnPad,
          fontSize: btnFs,
          fontWeight: 700,
          letterSpacing: '0.04em',
          color: active ? 'var(--neon-cy, #3DF0FF)' : 'var(--t-md, #888)',
          background: active ? 'rgba(61,240,255,0.10)' : 'transparent',
          boxShadow: active
            ? 'inset 0 0 0 1px var(--neon-cy, #3DF0FF)'
            : 'inset 0 0 0 1px rgba(255,255,255,0.10)',
          cursor: active ? 'default' : 'pointer',
          transition: 'all 160ms ease',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8
        }}
        aria-pressed={active}
      >
        <span style={{ fontSize: btnFs + 4 }}>{flag}</span>
        {label}
      </button>
    );
  }

  return (
    <div style={{ display: 'flex', gap: 8, width: '100%' }}>
      {btn('ru', '🇷🇺', t('lang.ru'))}
      {btn('en', '🇬🇧', t('lang.en'))}
    </div>
  );
}
